import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { CircleNotch, ForkKnife } from "@phosphor-icons/react";
import { DemoPage } from "@/components/demo/DemoPage";
import PublicSite from "@/pages/PublicSite";
import { AdminDemoBar } from "@/components/demo/AdminDemoBar";

function useNoIndex() {
  useEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex, nofollow, noarchive";
    document.head.appendChild(m);
    return () => { m.remove(); };
  }, []);
}

export default function DemoSite() {
  const { slug } = useParams();
  const [s, setS] = useState(null);
  const [err, setErr] = useState(false);
  useNoIndex();
  useEffect(() => {
    const preview = new URLSearchParams(window.location.search).get("preview") === "1";
    axios.get(`${API}/public/demo/${slug}${preview ? "?preview=true" : ""}`)
      .then(({ data }) => { setS(data); document.title = data.name; })
      .catch(() => setErr(true));
  }, [slug]);
  if (err) return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-2 bg-stone-50 p-6 text-center" data-testid="demo-not-found">
      <ForkKnife size={40} className="text-stone-500" /><h1 className="text-2xl font-semibold">Esta demonstração já não está disponível</h1>
    </div>
  );
  if (!s) return <div className="flex min-h-screen items-center justify-center bg-stone-900"><CircleNotch size={28} className="animate-spin text-white" /></div>;
  if (!s.layout) return <PublicSite demo />;
  return <><AdminDemoBar /><DemoPage s={s} /></>;
}
